"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPCRunModeBadge = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("../styled-components"));
const react_i18next_1 = require("react-i18next");
const Badge = styled_components_1.default.div `
  color: ${({ theme }) => theme.fgInverted};
  display: inline-block;
  padding: 2px 1ch;
  background: ${({ theme, mode }) => {
    switch (mode === null || mode === void 0 ? void 0 : mode.toUpperCase()) {
        case "AUTO":
        case "ENABLED":
            return theme.success;
        case "MANUAL":
            return theme.value;
        default:
            return theme.inactive;
    }
}};
  border-radius: ${({ theme }) => theme.radius};
  text-transform: uppercase;
  font-weight: 600;
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
/** An indicator with a coloured background for the IPC status of a job */
const IPCRunModeBadge = ({ mode }) => {
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    const statusForBadge = {
        Auto: t `label-ipcModeAuto`,
        Disabled: t `label-ipcModeDisabled`,
        Enabled: t `label-ipcModeEnabled`,
        Manual: t `label-ipcModeManual`,
    };
    if (!mode)
        return null;
    return react_1.default.createElement(Badge, { mode: mode }, statusForBadge[mode]);
};
exports.IPCRunModeBadge = IPCRunModeBadge;
//# sourceMappingURL=index.js.map